import { Badge, Tabs } from "antd";
const { TabPane } = Tabs;
const UiTab = ({
    onChange,
    activeTabKey,
    children,
    tabs,
    noBadge = false,
    count,
    ...restprops
}) => {
    return <>
        <Tabs defaultActiveKey={activeTabKey ? String(activeTabKey) : undefined} activeKey={activeTabKey ? String(activeTabKey) : undefined} onChange={onChange} {...restprops}>
            {tabs?.map((tab, index) => {
                const tabKey = (tab?.key !== undefined && tab?.key !== null) ? String(tab.key) : (index + 1).toString();
                const isActive = tabKey === String(activeTabKey);
                return <TabPane key={tabKey}
                    tab={
                        <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                            {tab.label}
                            {
                                !noBadge && (
                                    <Badge
                                        count={isActive ? count : ''}
                                        offset={[6, -2]}
                                        showZero
                                        color={isActive ? "#CCBA78" : "#F0F0F0"}
                                        overflowCount={9999}
                                    />
                                )
                            }
                        </span>
                    }
                    style={{ lineHeight: 0 }}>
                    {children}
                </TabPane>
            })}
        </Tabs>
    </>
};
export default UiTab